import { Button, Img, Line, Text } from "components";
import { useTranslation } from "react-i18next";
import AddMoney from "./AddMoney";
import React, { useEffect, useState } from "react";
import { addDeleteGetLocalStorage, storageKeys } from "utils/global/localData";
import { MoneyAdded } from "popups/MoneyAdded";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import * as CUSTOM from "../../../../utils/helper/custom";
import * as APIS from "../../../../utils/helper/Enum";
import { getAuth } from "../../../../redux/reducers/loginData";
import EmptyAll from "pages/EmptyList";

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [history, setHistory] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [apiStatus, setApiStatus] = useState(false);
  const [MoneyAddedOpen, setMoneyAddedOpen] = useState(false);
  const [addedAmount, setAddedAmount] = useState(0);
  const [isAddMoney, setIsAddMoney] = useState(false);
  const [paymentData, setPaymentData] = useState({ step: 1 });
  const auth = useSelector(getAuth);


  /**
   *  Get wallet history
   */
  const getWalletHistory = async () => {
    setApiStatus(false);
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS.USERS.WALLET_HISTORY,
        "get",
        {},
        { params: { page: 1, limit: 50000 } },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setHistory(
          CUSTOM.organizeDataByMonthAndYear(response?.data?.data, "createdAt")
        );
        setWalletBalance(response?.data?.wallet_balance);
      }
      setApiStatus(true);
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  const renderTransactionDetails = (items, auth, t) => {
    return items?.additionalNote;
  };

  useEffect(() => {
    if (!isAddMoney) {
      setPaymentData({ step: 1 });
    }
  }, [isAddMoney]);

  useEffect(() => {
    const responsePayment = addDeleteGetLocalStorage(
      storageKeys.WALLET_RESPONSE,
      {},
      "get"
    );
    if (responsePayment) {
      let dataJson = JSON.parse(responsePayment);
      if (dataJson?.payment_status == "success") {
        setMoneyAddedOpen(true);
        setAddedAmount(dataJson?.amount);
      } else {
        setMoneyAddedOpen(false);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: dataJson?.message,
            snackbarState: "error",
          })
        );
        setPaymentData({ ...paymentData, step: 2, amount: dataJson?.amount });
        setIsAddMoney(true);
      }
      addDeleteGetLocalStorage(storageKeys.WALLET_RESPONSE, {}, "delete");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getWalletHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const moneyProps = {
    setIsAddMoney: setIsAddMoney,
    paymentData: paymentData,
    setPaymentData: setPaymentData,
    getWalletHistory: getWalletHistory,
  };

  return (
    <>
      {isAddMoney ? (
        <AddMoney {...moneyProps} />
      ) : (
        <div className="flex flex-col w-full">
          <Text
            className="text-[24px] md:text-[22px] text-black-900 sm:text-xl font-medium leading-[32px] font-['Inter'] mb-5"
          >
            {t("wallet")}
          </Text>
          <div className="flex flex-row sm:flex-col items-center justify-between w-full bg-white border border-gray-200 rounded-xl px-5 py-4 mb-6 sm:items-start">
            <div className="flex flex-row items-center gap-3 sm:items-start">
              <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg">
                <Img
                  className="h-5 w-5"
                  src="/images/img_volume_black_900_28x28.svg"
                  alt="wallet"
                />
              </div>
              <div className="flex flex-col">
                <div className="flex flex-row items-center sm:items-start gap-1.5">
                <Text
                  className="text-[20px] font-semibold text-black-900 font-['Unbounded'] leading-tight"
                >
                  <Img
                    src="images/Groupsar2.svg"
                    alt="sar"
                    className="h-4 w-4 inline-block mr-1"
                  />
                  {t("sar")} {walletBalance}
                </Text>
                </div>
                <Text
                  className="text-gray-500 text-xs font-['Inter'] mt-0.5"
                >
                  {t("walletBalance")}
                </Text>
              </div>
            </div>

            {/* Right: Add Balance button */}
            <Button
              className="flex items-center gap-1.5 px-4 h-9 rounded-full border hover:text-black-900 border-gray-300 bg-white text-black-900 text-sm font-medium font-['Unbounded'] sm:mt-4 sm:ml-[20%]"
              size={"sm"}
              hover={false}
              onClick={() => setIsAddMoney(true)}
              leftIcon={
                <Img
                  className="h-4 w-4 btn-icon"
                  src="/images/img_plus_black_900_20x20.svg"
                  alt="plus"
                />
              }
            >
              <span className="text-[14px] font-['Unbounded']">{t("moneyToWallet")}</span>
            </Button>
          </div>
          {history.length > 0 && (
            <Text
              className="text-[18px] font-medium text-black-900 font-['Inter'] mb-4 leading-[24px"
            >
              {t("transactionHistory")}
            </Text>
          )}

          <div className="relative w-full mb-8">
            {history.map((monthData, indexindex) => {
              const monthName = Object.keys(monthData)[0];
              const transactions = monthData[monthName];
              return (
                <div key={`month-${indexindex}`}>

                  <div className="mb-2 mt-4 first:mt-0">
                    <Text
                      className="text-[18px] font-semibold text-gray-400 uppercase tracking-wide font-['Inter']"
                    >
                      {monthName}
                    </Text>
                  </div>

                  <div className="bg-[white] border border-gray-200 rounded-xl overflow-hidden mb-2">
                    {transactions.map((items, indexitems) => {
                      const isDebit = items?.orderType === "order";
                      return (
                        <React.Fragment key={`wallet-items-${items?.id}`}>
                          <div className="flex flex-row sm:flex-col items-center justify-between px-4 py-3.5">

                            {/* Left: icon with status dot */}
                            <div className="flex items-center gap-3">
                              <div className="relative flex-shrink-0">
                                <div className="flex items-center justify-center w-9 h-9 bg-gray-100 rounded-lg">
                                  <Img
                                    className="h-5 w-5"
                                    src={CUSTOM.walletPaymentStatusLogo(
                                      items?.transactionDetails?.type
                                    )}
                                    alt="transaction"
                                  />
                                </div>
                                {/* Status dot */}
                                <span
                                  className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-white ${
                                    isDebit ? "bg-red-400" : "bg-green-400"
                                  }`}
                                />
                              </div>

                              {/* Name + Date */}
                              <div className="flex flex-col gap-0.5">
                                <Text
                                  className="text-[18px] font-medium leading-[28px] text-[#1A1A1A] sm:text-[16px]"
                                  style={{ fontFamily: "Inter" }}
                                >
                                  {renderTransactionDetails(items, auth, t)}
                                </Text>
                                <Text
                                  className="text-[14px] font-normal leading-[20px] text-[#727783] text-start"
                                  style={{ fontFamily: "Inter" }}
                                >
                                  {CUSTOM.convertDateString(
                                    items?.createdAt,
                                    "dd/MM/yyyy · hh:mm a"
                                  )}
                                </Text>
                              </div>
                            </div>

                            {/* Right: Amount */}
                            <div className="flex flex-row items-end gap-0.5 sm:mr-[60%] sm:mt-4 ">
                              <Text
                                className={`flex flex-row items-center justify-center 
                                            text-[20px] font-medium leading-[28px] sm:text-[18px]
                                            ${isDebit ? "text-red-500" : "text-[#1A1A1A]"}`}
                                style={{ fontFamily: "Unbounded" }}
                              >
                                {isDebit ? "-" : ""}
                                <Img
                                  src="images/Groupsar2.svg"
                                  alt="sar"
                                  className="h-4 w-4 mt-[2px]"
                                />
                                &nbsp;
                                {CUSTOM.setPrice(items?.transactionDetails?.walletAmount)}
                              </Text>
                              {/* <Text
                                className="text-xs text-gray-400 font-['Inter']"
                                size="txtnunitoRegular12Gray700"
                              >
                                {t("closingBal")}: {t("sar")}{" "}
                                {CUSTOM.setPrice(items?.walletClosingBalance)}
                              </Text> */}
                            </div>
                          </div>

                          {/* Separator */}
                          {indexitems !== transactions.length - 1 && (
                            <div className="h-px bg-gray-100 mx-4" />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              );
            })}

            {/* Empty state */}
            {history.length === 0 && apiStatus ? (
              <EmptyAll type="walletHistory" />
            ) : null}
          </div>
        </div>
      )}
      {MoneyAddedOpen ? (
        <MoneyAdded closepopup={setMoneyAddedOpen} addedAmount={addedAmount} />
      ) : null}
      {/* after click // money to wallet button // show below content  */}
    </>
  );
};

export default Wallet;
